module.exports = __webpack_public_path__ + "4288ef1ca24101d938d66e31f5b9e7ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/info.png
// module id = 217
// module chunks = 0